import { render, staticRenderFns } from "./MoveVehicleContractWizard.vue?vue&type=template&id=2c1ab148"
import script from "./MoveVehicleContractWizard.vue?vue&type=script&lang=ts"
export * from "./MoveVehicleContractWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports